import { INTERNATIONAL_COUNTRY_CODE, VACANCY_CUSTOM_FIELD_NAMES, PREFERRED_CAREER_COUNTRIES } from '../../shared/config/constants';
import { resolveCountryCode } from '../../shared/utils';

export const filterVacanciesByCountryCode = (vacancies, countryCode) => {
    const code = PREFERRED_CAREER_COUNTRIES.find(country => country.code === countryCode)?.code ?? INTERNATIONAL_COUNTRY_CODE;

    if (!vacancies) {
        return [];
    }

    if (code === INTERNATIONAL_COUNTRY_CODE) {
        return vacancies;
    }

    return vacancies.filter((vacancy) => {
        if (Array.isArray(vacancy.custom_fields)) {
            const countryField = vacancy.custom_fields.find(
                field => field.internal_name === VACANCY_CUSTOM_FIELD_NAMES.countries
            );

            if (countryField && Array.isArray(countryField.value)) {
                const upperResolvedCodes = countryField.value
                    .map(code => {
                        const resolved = resolveCountryCode(code);

                        return (typeof resolved === 'string' ? resolved.toUpperCase() : null)
                            || (typeof code === 'string' ? code.toUpperCase() : null);
                    })
                    .filter(Boolean);
                const targetCode = code.toUpperCase();

                return upperResolvedCodes.includes(targetCode);
            }
        }

        return false;
    });
};
